import { IDeliverable } from '@sdk/contracts';
import { Button, InputNumber } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ScoreTextWrapper, ScoreWrapper, Wrapper } from './DeliverableScore.styles';

import { useMutateDeliverables } from '@/store';

type Props = {
  deliverable: IDeliverable;
  isEditable: boolean;
};

export const DeliverableScore: FC<Props> = ({ deliverable, isEditable }) => {
  const { t } = useTranslation('DeliverableListTranslations');
  const { updateDeliverable, isWorking } = useMutateDeliverables();
  const [isEditing, setIsEditing] = useState(false);
  const [newScore, setNewScore] = useState<number>();

  const hasScore = Boolean(deliverable?.score);

  useEffect(() => {
    if (deliverable?.score && !isEditing) {
      setNewScore(deliverable.score);
    }
  }, [deliverable?.score]);

  const onRate = () =>
    updateDeliverable(
      {
        _id: deliverable._id,
        status: deliverable.status,
        score: newScore
      },
      {
        onSuccess: () => {
          setIsEditing(false);
        }
      }
    );

  return isEditable ? (
    <>
      {hasScore || isEditing ? (
        <Wrapper>
          <InputNumber
            min={0}
            max={10}
            type="number"
            value={newScore}
            disabled={!isEditing || isWorking}
            onChange={val => setNewScore(val ?? undefined)}
          />
          {isEditing ? (
            <Button disabled={!newScore} loading={isWorking} onClick={onRate}>
              {t('SAVE')}
            </Button>
          ) : (
            <Button loading={isWorking} onClick={() => setIsEditing(true)}>
              {t('EDIT')}
            </Button>
          )}
        </Wrapper>
      ) : (
        <Button onClick={() => setIsEditing(true)}>{t('RATE')}</Button>
      )}
    </>
  ) : (
    <Wrapper>
      <ScoreTextWrapper>{t('SCORE')}</ScoreTextWrapper>
      <ScoreWrapper>{deliverable.score ?? '-'}</ScoreWrapper>
    </Wrapper>
  );
};
